import { TOGGLE_FIRST_VIDEO_SHARE_MODAL } from 'constants/actions';

const DEFAULT_STATE = {
  isOpen: false,
};

const firstVideoShareModalReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case TOGGLE_FIRST_VIDEO_SHARE_MODAL:
      return {
        ...state,
        isOpen: action.isOpen,
      };
    default:
      return state;
  }
};

export default firstVideoShareModalReducer;
